import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationsLoader } from '@common/loaders/translations-loader';
import { ComponentsModule } from '@common/components/components.module';
import { ServicesModule } from '@common/services/services.module';
import { AppComponent } from './app.component';
import { RoutingModule } from '@common/routing/routing.module';
import { AuthModule } from '@modules/auth/auth.module';
import { ContainerModule } from '@modules/container/container.module';
import { DashboardModule } from '@modules/dashboard/dashboard.module';
import { EmployeesModule } from '@modules/employees/employees.module';
import { ClientsModule } from '@modules/clients/clients.module';

export function httpLoaderFactory(http: HttpClient) {
  return new TranslationsLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ComponentsModule,
    ClientsModule,
    ContainerModule,
    DashboardModule,
    EmployeesModule,
    ServicesModule,
    AuthModule,
    RoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts